var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content px-0 bg-white p-0 h-100 pt-4"},[_c('div',{staticClass:"container-fluid h-100"},[_c('div',{staticClass:"row h-100"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }